module.exports = __webpack_public_path__ + "static/game-surselva-segelmeister-5b7280e1e31b73734bf02ca336e8f3d2.png";